<template>
  <singleWithBlock v-if="!content.category || content.category === 1" :content="content"></singleWithBlock>
  <tabsLevel2 v-else-if="content.category === 2" :content="content"></tabsLevel2>
  <collapseTemplate v-else-if="content.category === 3" :content="content"></collapseTemplate>
</template>
<script>
/*
结构组件
*/
import singleWithBlock from "./singleWithBlock.vue";
import tabsLevel2 from "./tabsLevel2.vue";
import collapseTemplate from "./collapse.vue";
import evaluationIndex from "../evaluation/index.vue";//英语最后一节

export default {
  name: "paragraphIndex",
  components: {
    singleWithBlock,
    tabsLevel2,
    collapseTemplate,
    evaluationIndex
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
}
</script>